<template>
  <div id="app">
    <transition 
      enter-active-class="transition duration-300 ease-out transform" 
      enter-class="opacity-0" 
      enter-to-class="opacity-100" 
      leave-active-class="transition duration-150 ease-in transform" 
      leave-class="opacity-100" 
      leave-to-class="opacity-0"
    >
      <div v-show="is_loading" class="s-spinner-bg fixed top-0 right-0 h-screen w-screen z-100 flex justify-center items-center cursor-not-allowed	">
        <div class="s-spinner animate-spin rounded-full" />
      </div>
    </transition>

    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AppVue',
  computed: {
    ...mapState([
      'show_disclaimer',
      'results',
      'is_loading'
    ])
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

</style>
